import styled from 'styled-components';

export const GeneVolcanoPointsGridWrapper = styled.div`
    height: 400px;
`;

export const DifferentialExpressionInfo = styled.div`
    margin-bottom: 10px;
`;
